import { defineMessages } from 'react-intl';

export default defineMessages({
    policyDetailsTitle: {
        id: 'quoteandbind.wizard.step.Policy Details',
        defaultMessage: 'Policy Details',
    },
    effectiveDate: {
        id: 'twia.quoteandbind.views.contact-details.Requested Coverage Start Date',
        defaultMessage: 'Requested Coverage Start Date',
    },
    fieldLabel: {
        id: 'twia.quoteandbind.ho.views.policy-info.Primary Named Insured',
        defaultMessage: 'Primary Named Insured',
    },
    fieldLabelCompany: {
        id: 'twia.quoteandbind.ho.views.policy-info.Name',
        defaultMessage: 'Name',
    },
    saveModalTitle: {
        id: 'twia.quoteandbind.ho.views.policy-info.Please save or cancel',
        defaultMessage: 'Please save or cancel',
    },
    saveModalText: {
        id: 'twia.quoteandbind.ho.views.policy-info.Please save or cancel changes before continuing',
        defaultMessage: 'Please save or cancel changes before continuing',
    }
})